import { render } from "./SaldoModal.vue?vue&type=template&id=6cb53620&scoped=true"
import script from "./SaldoModal.vue?vue&type=script&lang=js"
export * from "./SaldoModal.vue?vue&type=script&lang=js"

import "./SaldoModal.vue?vue&type=style&index=0&id=6cb53620&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cb53620"

export default script